import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Love } from './Love.tsx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "love-emoji"
    }}>{`Love Emoji`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Love} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={1} __code={'<Love />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Love,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Love mdxType="Love" />
    </Playground>
    <h2 {...{
      "id": "different-sizes"
    }}>{`Different sizes`}</h2>
    <Playground __position={2} __code={'<div style={{ display: \'flex\', padding: 20, flexWrap: \'wrap\' }}>\n  <Love size={3} />\n  <Love size={4} />\n  <Love size={5} />\n  <Love size={6} />\n  <Love size={7} />\n  <Love size={8} />\n  <Love size={9} />\n  <Love size={10} />\n</div>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Love,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <div style={{
        display: "flex",
        padding: 20,
        flexWrap: 'wrap'
      }}>
    <Love size={3} mdxType="Love" />
    <Love size={4} mdxType="Love" />
    <Love size={5} mdxType="Love" />
    <Love size={6} mdxType="Love" />
    <Love size={7} mdxType="Love" />
    <Love size={8} mdxType="Love" />
    <Love size={9} mdxType="Love" />
    <Love size={10} mdxType="Love" />
  </div>
    </Playground>
    <h2 {...{
      "id": "no-animations"
    }}>{`No animations`}</h2>
    <Playground __position={3} __code={'<Love animate={false} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Love,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Love animate={false} mdxType="Love" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      